<template>
  <div class="text-ellipsis">
    <span v-if="displayValue">{{ displayValue }}</span>
    <span v-else>--</span>
  </div>
</template>

<script>
export default {
  props: ['params'],
  computed: {
    displayValue() {
      return this.params.accessDeviceName || this.params.accessDeviceId || '';
    }
  }
};
</script>
